<script setup lang="ts">
import type { CartCommentControl } from "../cartControls";

defineProps<{ control: CartCommentControl }>();
</script>

<template>
	<button
		type="button"
		class="buttonDefaultWrapper"
		:disabled="control.disabled"
		:id="control.disabled ? 'buttonDefaultDisabled' : ''"
		@click="control.toggle()"
	>
		{{ control.label }}
	</button>
</template>
